import type { IconProps } from '@src/components/icons/IconProps';

/**
 * Filled help disc from Santa 2026 FAQ (node 78:6919) and santa-frontend's
 * IconFaq. The disc is currentColor; the mark punches through in the surface
 * colour so it stays a quiet badge, not a heavy outline.
 */
export function HelpIcon({ className }: IconProps) {
  return (
    <svg
      className={['help-icon', className].filter(Boolean).join(' ')}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="12" cy="12" r="10" fill="currentColor" />
      <path
        d="M9.7 9.7A2.2 2.2 0 0111.9 8a2.15 2.15 0 012.25 2c0 1.5-2.15 2-2.15 3"
        stroke="var(--color-surface)"
        strokeWidth="var(--icon-stroke-thin)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="15.75" r="1" fill="var(--color-surface)" />
    </svg>
  );
}
